import Raven from 'raven-js';
import { property } from 'lodash-es';
import { selectors as current } from '../current';
import { matchers as inviteMatchers } from '../invite';
import { matchers as sessionMatchers } from '../session';
import { matchers } from '../http-request';

export function ErrorEpic() {
  return (action, { dispatch, getState }) => {
    if (
      sessionMatchers.isCreateSuccess(action) ||
      sessionMatchers.isReadSuccess(action)
    ) {
      const state = getState();
      const user = current.user(state);
      Raven.setUserContext({
        uuid: user.uuid(state),
        email: user.email(state),
      });
    } else if (inviteMatchers.isReadSuccess(action)) {
      const attributes = property('payload.data.attributes')(action);
      Raven.setUserContext({
        uuid: attributes.uuid,
        email: attributes.email,
      });
    } else if (
      sessionMatchers.isDestroySuccess(action) ||
      sessionMatchers.isDestroyError(action) ||
      sessionMatchers.isReadError(action) ||
      matchers.isRequestResponseStatus.unauthorized(action)
    ) {
      Raven.setUserContext();
    }
  };
}
